import { createFileRoute } from '@tanstack/react-router'
import { BookPage } from '../components/pages/BookPage'
import { throwLegacyRedirect } from '../lib/legacy-redirect'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/book')({
  beforeLoad: ({ location }) => {
    throwLegacyRedirect(location.pathname, location.searchStr)
  },
  component: BookPage,
  head: () => publicPageHead({
    title: 'Book Ceramic Protection | Autoglow Detailing',
    description:
      'Book GYEON ceramic protection with Autoglow in Drysdale. Choose 1, 3 or 5 year protection, add-ons if you want them, then pay a $100 booking deposit and pick an appointment.',
    path: '/book',
  }),
})
